<template>
  <section class="section winners">
    <div class="gradient" />
    <div class="inner-section">
      <h2>{{ title }}</h2>
      <div class="ranking">
        <div class="top3">
          <div class="rank first">
            <div class="infos u-d-f u-jc-sb u-ai-c">
              <p class="position">1<sup>ère</sup> place</p>
              <div class="waper">
                <img
                  :src="posts[0].wc_post?.user?.avatar?.url"
                  class="p-waper__avatar"
                  loading="lazy"
                />
                <p class="p-waper__nickname">
                  {{ posts[0].wc_post?.user?.nickname }}
                </p>
              </div>
            </div>
            <div class="winner-content">
              <img
                :src="posts[0].wc_post?.image?.url"
                alt=""
                loading="lazy"
              />
            </div>
          </div>
          <div
            v-if="posts.length > 1"
            class="rank second"
          >
            <div class="infos">
              <p class="position">2<sup>ème</sup> place</p>
              <div class="waper">
                <img
                  :src="posts[1].wc_post?.user?.avatar?.url"
                  class="p-waper__avatar"
                  loading="lazy"
                />
                <p class="p-waper__nickname">
                  {{ posts[1].wc_post?.user?.nickname }}
                </p>
              </div>
            </div>
            <div class="winner-content">
              <img
                :src="posts[1].wc_post?.image?.url"
                alt=""
                loading="lazy"
              />
            </div>
          </div>
          <div
            v-if="posts.length > 2"
            class="rank third"
          >
            <div class="infos">
              <p class="position">3<sup>ème</sup> place</p>
              <div class="waper">
                <img
                  :src="posts[2].wc_post?.user?.avatar?.url"
                  class="p-waper__avatar"
                  loading="lazy"
                />
                <p class="p-waper__nickname">
                  {{ posts[2].wc_post?.user?.nickname }}
                </p>
              </div>
            </div>
            <div class="winner-content">
              <img
                :src="posts[2].wc_post?.image?.url"
                alt=""
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <div
          v-if="posts.length > 3"
          class="others"
        >
          <div
            v-for="(post, index) in othersPosts"
            :key="`waper-${index}`"
            :ref="`image-${index}`"
            class="rank rank-grid"
          >
            <div class="content">
              <div class="infos">
                <p class="position">{{ index + 4 }}<sup>ème</sup> place</p>
                <div class="waper">
                  <img
                    :src="post?.wc_post?.user?.avatar?.url"
                    class="p-waper__avatar"
                    loading="lazy"
                  />
                  <p class="p-waper__nickname">
                    {{ post.wc_post?.user?.nickname }}
                  </p>
                </div>
              </div>
              <div
                v-if="post.wc_post?.image?.url"
                class="winner-content"
              >
                <img
                  :src="post.wc_post.image.url"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { CustomWallContest } from '~/types'

const props = withDefaults(
  defineProps<{
    posts?: CustomWallContest['winners']
    title?: string
  }>(),
  {
    posts: () => [],
    title: '',
  },
)

const othersPosts = computed(() => {
  return props.posts.slice(3, props.posts.length)
})
</script>

<style lang="scss" scoped>
.winners {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 105px 0;
  overflow: hidden;
  background: #032874;

  @media screen and (max-width: 992px) {
    padding-top: 50px;
  }

  .gradient {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 0;
    width: 100vw;
    height: 100%;
    background: radial-gradient(circle, rgb(13 72 168 / 1) 0%, #032874 100%);
    transform: translate(-50%, -50%);
  }

  .inner-section {
    position: relative;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 80px;

    @media screen and (max-width: 700px) {
      padding: 0 2.5rem;
    }

    h2 {
      color: $white;
      font-family: SST;
      font-size: 39px;
      font-weight: 500;
      letter-spacing: 0;
      text-align: center;
      text-transform: none;

      @media screen and (max-width: 700px) {
        font-size: 24px;
      }
    }

    .ranking {
      margin-top: 116px;

      @media screen and (max-width: 992px) {
        margin-top: 95px;
      }

      @media screen and (max-width: 700px) {
        margin-top: 50px;
      }

      .top3 {
        border-top: 1px solid #fff;
        border-bottom: 1px solid #fff;

        .first {
          padding-bottom: 30px;
          border-bottom: 1px solid #fff;

          .infos {
            width: 100%;
            padding: 20px 0;

            @media screen and (max-width: 375px) {
              flex-direction: column;
            }

            .position {
              flex-shrink: 0;
              margin-right: 10px;
              font-size: 30px;

              @media screen and (max-width: 992px) {
                font-size: 29px;
              }

              @media screen and (max-width: 700px) {
                font-size: 22px;
              }
            }

            .waper {
              margin-top: 0;
              margin-bottom: 0;

              @media screen and (max-width: 375px) {
                margin-top: 10px;
              }

              .p-waper__avatar {
                width: 80px;
                height: 80px;
                margin-right: 34px;
                border-radius: 40px;

                @media screen and (max-width: 992px) {
                  width: 70px;
                  height: 70px;
                  margin-right: 25px;
                  border-radius: 35px;
                }

                @media screen and (max-width: 700px) {
                  width: 42px;
                  height: 42px;
                  margin-right: 10px;
                  border-radius: 21px;
                }
              }

              .p-waper__nickname {
                height: 24px;
                font-size: 22px;

                @media screen and (max-width: 700px) {
                  font-size: 18px;
                }
              }
            }
          }
        }

        .second {
          display: flex;
          flex-direction: row-reverse;
          justify-content: flex-end;
          align-items: center;
          padding: 30px 0;
          border-bottom: 1px solid #fff;

          @media screen and (max-width: 375px) {
            flex-direction: column;
            justify-content: center;
          }

          .infos {
            .waper {
              margin-bottom: 0;

              @media screen and (max-width: 375px) {
                margin-top: 10px;
              }
            }
          }

          .winner-content {
            width: 75%;
            margin-right: 50px;

            @media screen and (max-width: 375px) {
              width: 100%;
              margin-top: 20px;
              margin-right: 0;
            }
          }
        }

        .third {
          display: flex;
          flex-direction: row-reverse;
          justify-content: flex-end;
          align-items: center;
          padding: 30px 0;

          @media screen and (max-width: 375px) {
            flex-direction: column;
            justify-content: center;
          }

          .infos {
            .waper {
              margin-bottom: 0;

              @media screen and (max-width: 375px) {
                margin-top: 10px;
              }
            }
          }

          .winner-content {
            width: 50%;
            margin-right: 50px;

            @media screen and (max-width: 375px) {
              width: 100%;
              margin-top: 20px;
              margin-right: 0;
            }
          }
        }
      }

      .rank {
        color: $white;

        .winner-content {
          img {
            width: 100%;
          }
        }

        .position {
          color: $white;
          font-family: SST;
          font-size: 22px;
          font-weight: 500;
          letter-spacing: 0;
        }

        .infos {
          @media screen and (max-width: 375px) {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }

        .waper {
          position: relative;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 10px;
          margin-bottom: 20px;
          color: $white;

          .p-waper__avatar {
            flex-shrink: 0;
            width: 42px;
            height: 42px;
            margin-right: 10px;
            overflow: hidden;
            border-radius: 21px;
            object-fit: cover;

            @media screen and (max-width: 1280px) {
              width: 28px;
              height: 28px;
              border-radius: 14px;
            }

            @media screen and (max-width: 700px) {
              width: 36px;
              height: 36px;
              border-radius: 18px;
            }
          }

          .p-waper__nickname {
            flex-grow: 1;
            height: 18px;
            overflow: hidden;
            color: $white;
            font-family: SST;
            font-size: 16px;
            font-weight: 700;
            text-overflow: ellipsis;
            white-space: nowrap;
            -webkit-line-clamp: 1;
          }
        }
      }

      .others {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 40px;

        .rank {
          width: 33.3%;
          margin-top: 30px;
          padding: 0 10px;
        }

        @media screen and (max-width: 1280px) {
          .rank {
            width: 50%;
          }
        }

        @media screen and (max-width: 700px) {
          margin-top: 50px;

          .rank {
            width: 100%;
            padding: 0;
          }
        }

        @media screen and (max-width: 375px) {
          margin-top: 30px;
        }

        &::after {
          content: '';
          flex: auto;
        }
      }
    }
  }
}
</style>
